export default __webpack_public_path__ + "static/media/payments-2.bed586bf.jpg";